import React, { useContext, useEffect, useState } from "react";
export default function NotFound() {
    useEffect(() => {
    }, []);


    return (
        <>
            <div className="container col-xl-10 col-xxl-8 px-4 py-5">
                <div className="row align-items-center g-lg-5 py-5">
                    <h1>صفحه مورد نظر یافت نشد</h1>
                </div>
            </div>
        </>

    );

}
